import { ActivationAndFlightPlan, ActivationCriteria, ActivationStatusEnum } from '@/types/utm/flightPlan.types';

import { UTM_URL, utmApi } from './utm.api';

export const ACTIVATIONS_TAG: { type: 'Activation'; id: string } = { type: 'Activation', id: 'LIST' };

export const activationApi = utmApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivations: builder.query<ActivationAndFlightPlan[], ActivationCriteria>({
      query: ({
        organizations,
        externalIds,
        collaborativeIds,
        from,
        to,
        statuses,
        withConflicts,
        sortTypeAndDirection,
      }) => ({
        url: `${UTM_URL}/activations`,
        params: {
          organizations,
          externalIds,
          collaborativeIds,
          from,
          to,
          statuses,
          withConflicts,
          sortTypeAndDirection,
        },
      }),
      providesTags: [ACTIVATIONS_TAG],
    }),
    getConflicting: builder.query<ActivationAndFlightPlan[], { id: number }>({
      query: ({ id }) => ({
        url: `${UTM_URL}/activations/${id}/conflicting`,
      }),
    }),
    patchStatus: builder.mutation<ActivationAndFlightPlan, { id: number; status: ActivationStatusEnum }>({
      query: ({ id, status }) => ({
        url: `${UTM_URL}/activations/${id}/status`,
        method: 'PATCH',
        body: { status },
      }),
    }),
    deleteActivation: builder.mutation<void, number>({
      query: (id) => ({
        url: `${UTM_URL}/activations/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetActivationsQuery,
  useLazyGetActivationsQuery,
  useGetConflictingQuery,
  usePatchStatusMutation,
  useDeleteActivationMutation,
} = activationApi;
